import React, { useCallback, useEffect, useRef, useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';

import { PiDotsThreeOutlineVerticalBold } from 'react-icons/pi';
import { FaPlus } from 'react-icons/fa';
import { HiTrendingUp } from 'react-icons/hi';

import { TieredMenu } from 'primereact/tieredmenu';
import { getAxios } from '../../axios/Axios';
import request from '../../request/request';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Loader from '../loader/Loader';
import { InputText } from 'primereact/inputtext';
import { Button } from 'react-bootstrap';
import { Paginator } from 'primereact/paginator';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import GlobalCategoryListFilterDrawer from './GlobalCategoryListFilterDrawer';
import { formatNumberWithCommas } from '../../utils/helper';
import { useGlobal } from '../../context/GlobalContext';

const GlobalCategoryList = () => {
	const { setDashboardTitle } = useGlobal();
	const [globalCategoryList, setGlobalCategoryList] = useState();
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [first, setFirst] = useState(0);
	const [rows, setRows] = useState(50);
	const [currentPage, setCurrentPage] = useState(1);
	const [levelType, setLevelType] = useState('');
	const navigate = useNavigate();
	const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
	// const [isResetting, setIsResetting] = useState(false);
	const levelItems = [
		// { name: 'Reset Level', value: '' },
		{ name: 'Level 1', value: '1' },
		{ name: 'Level 2 ', value: '2' },
		{ name: 'Level 3 ', value: '3' },
	];

	const fetchData = useCallback(async () => {
		try {
			setLoading(true);
			const params = {
				page: currentPage,
				rows,
				more_details: 1,
			};

			if (searchText?.trim()) params.term = searchText.trim();
			if (levelType) params.level = levelType;

			const response = await getAxios(`${request.globalCategoryList}`, {
				params,
			});
			if (response?.data.apiresponse?.type === 'OK') {
				setGlobalCategoryList(response?.data);
			}

			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	}, [searchText, currentPage, rows, levelType]);

	useEffect(() => {
		fetchData();
	}, [first, currentPage, rows]);

	const handleSearch = useCallback(() => {
		fetchData();
		setFilterDrawerVisible(false);
	}, [fetchData]);

	const handleResetFilter = useCallback(() => {
		setSearchText('');
		setLevelType('');
		setFirst(0);
		setCurrentPage(1);
		setFilterDrawerVisible(false);
		fetchData();
	}, [fetchData]);

	const onPageChange = (event) => {
		setFirst(event.first);
		setCurrentPage(event.page + 1);
		setRows(event.rows);
	};

	const renderCount = (rowData, { rowIndex }) => {
		const serialNumber = first + rowIndex + 1;
		return (
			<div className="flex justify-content-evenly gap-1">{serialNumber}</div>
		);
	};

	const renderCategoryName = (rowData) => {
		return (
			<div className="webiste-detail-container">
				<div className="d-flex gap-1">
					<div>{rowData?.category_name}</div>
					{rowData?.product_placement[0]?.position_type_id === 'HOME_PAGE' && (
						<div className="category-details-id">
							<HiTrendingUp fill="green" stroke="green" width={40} />
							{/* <img  src='/images/trend_cats.svg'  width={20} /> */}
						</div>
					)}
				</div>
				<div className="category-details-id">
					<span>{rowData?.product_category_id}</span>
				</div>

				<div className="d-flex gap-2 b2b-wrapper">
					<span className="b2b-span">
				
						{rowData?.classifications?.map((classification, index) => (
							<React.Fragment key={classification.classification_group_id}>
								{classification.classification_group_id}
								{index < rowData.classifications.length - 1 && (
									<span style={{ color: ' #d4d9de' }}> | </span>
								)}
							</React.Fragment>
						))}
					</span>
				</div>
			</div>
		);
	};

	const renderParentCategory = (rowData) => {
		return (
			<div className="webiste-detail-container">
				<div>{rowData?.parent_category_name}</div>
				<div className="category-details-id">
					<span>{rowData?.primary_parent_category_id}</span>
				</div>
			</div>
		);
	};

	const renderIcon = (rowData) => {
		const categoryIcon = rowData.category_contents?.find(
			(content) => content.content_type_id === 'CATEGORY_ICON'
		);
		return categoryIcon ? (
			<div className="d-flex justify-content-center">
				<img
					src={categoryIcon.object_info.small.public_url}
					alt="Category Icon"
					// width={100}
					height={50}
				/>
			</div>
		) : (
			<div className="d-flex justify-content-center">
				<img src="/images/no-icon.webp" alt="Category Icon" height={50} />
			</div>
		);
	};
	const renderActions = (rowData) => {
		const menu = useRef(null);
		const navigate = useNavigate();
		const items = [
			{
				label: 'Edit',
				icon: 'pi pi-file-edit',
				command: () => {
					navigate(
						`/update-product-category?id=${rowData?.product_category_id}`,
						{ state: rowData?.product_category_id }
					);
				},
			},

			{
				label: 'Create Category Advertisment',
				icon: 'pi pi-file-edit',
				command: () => {
					navigate(
						`/create-category-advertisment?id=${rowData?.product_category_id}`,
						{ state: rowData?.product_category_id }
					);
				},
			},
		];
		return (
			<div className=" cursor-pointer flex justify-content-center">
				<TieredMenu model={items} popup ref={menu} breakpoint="767px" />
				<span
					className="global-category-action"
					icon="pi pi-check"
					aria-label="Filter"
					label="Show"
					onClick={(e) => menu.current.toggle(e)}
				>
					<PiDotsThreeOutlineVerticalBold />
				</span>
			</div>
		);
	};

	const renderDescription = (rowData) => {
		const categoryBanner = rowData.category_contents?.filter(
			(content) => content.content_type_id === 'CATEGORY_BANNER'
		);

		return (
			<div className=" d-flex flex-column">
				<div>{rowData?.description}</div>
				<div className="d-flex  align-items-start gap-1">
					{categoryBanner?.map((fileURL, index) => {
						return (
							<div key={index} className="testing-banner align-items-start  ">
								<img
									src={fileURL?.object_info?.small?.public_url}
									alt={`Banner Preview ${index}`}
								/>
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	useEffect(()=> {
		setDashboardTitle('Global Category List');
	}, [])

	return (
		<div>
			{loading && <Loader />}

			<div className="m-2 d-flex gap-2 justify-content-between align-items-center  w-100">
				<div className="pr-3">
					<span className="font-bold ">Total Records:</span>
					<span> {globalCategoryList?.metadata?.total ? formatNumberWithCommas(globalCategoryList?.metadata?.total) : 0} </span>
				</div>
				<div
					style={{ width: '75%' }}
					className="d-flex gap-2 flex-row  justify-content-end align-items-center  prime-react-btn"
				>
					<Button
						variant="outline-secondary"
						disabled={loading}
						title='filter'
						onClick={() => setFilterDrawerVisible(true)}
					>
						<i className="pi pi-filter" />
					</Button>
					<button
						className="btn submit-btn text-white"
						disabled={loading}
						title='refresh'
						onClick={!loading ? fetchData : null}
					>
						<IoMdRefresh size="1.3em" />
					</button>
					<Button
						variant="outline-secondary"
						title='Add a category'
						disabled={loading}
						onClick={() => navigate('/add-new-category')}
					>
						<i className="pi pi-plus" />
					</Button>
				</div>
			</div>

			<DataTable value={globalCategoryList?.record} showGridlines>
				<Column body={renderCount} header="S.No" />
				<Column style={{ textAlign: 'center' }} field="level" header="Level" />
				<Column body={renderIcon} header="Category Icon" />
				<Column body={renderCategoryName} header="Category Name" />
				<Column body={renderParentCategory} header="Parent Category" />
				<Column
					style={{ maxWidth: '300px' }}
					body={renderDescription}
					header="Description"
				/>
				<Column
					field="product_category_type_id"
					header="Product Category Type ID"
				/>
				<Column body={renderActions} header="Action" />
			</DataTable>

			<Paginator
				first={first}
				rows={rows}
				totalRecords={globalCategoryList?.metadata?.total}
				rowsPerPageOptions={[50, 100, 150, 200, 250]}
				onPageChange={onPageChange}
			/>

			<GlobalCategoryListFilterDrawer
				filterDrawerVisible={filterDrawerVisible}
				setFilterDrawerVisible={setFilterDrawerVisible}
				levelType={levelType}
				setLevelType={setLevelType}
				levelItems={levelItems}
				searchText={searchText}
				setSearchText={setSearchText}
				loading={loading}
				handleResetFilter={handleResetFilter}
				handleSearch={handleSearch}
			/>
		</div>
	);
};

export default GlobalCategoryList;
